import logoWhite from "./brand/logo-white.svg";

import centerbridgeLogo from "./logos/cp.svg";
import morganStanleyLogo from "./logos/ms.svg";
import norfolkSouthernLogo from "./logos/ns.svg";
import thomaBravoLogo from "./logos/tp.svg";
import blackRockLogo from "./logos/br.svg";
import nasaLogo from "./logos/na.svg";
import generalDynamicsLogo from "./logos/gd.svg";
import dodLogo from "./logos/ud.svg";
import visaLogo from "./logos/va.svg";
import payPalLogo from "./logos/pp.svg";
import eBayLogo from "./logos/ey.svg";

/**
 * Brand image registry for shared navigation and footer usage.
 * Translation: Brand image registry for shared navigation and footer usage.
 */
export const brandAssets = {
  logoWhite,
};

/**
 * Partner and team logo registry with source-based sizing metadata.
 * Translation: Partner and team logo registry with source-based sizing metadata.
 */
export const logoRegistry = {
  centerbridge: {
    src: centerbridgeLogo,
    alt: "Centerbridge",
    mobileHeight: 40,
    desktopHeight: 72,
  },
  morganStanley: {
    src: morganStanleyLogo,
    alt: "Morgan Stanley",
    mobileHeight: 40,
    desktopHeight: 72,
  },
  norfolkSouthern: {
    src: norfolkSouthernLogo,
    alt: "Norfolk Southern",
    mobileHeight: 52,
    desktopHeight: 96,
  },
  thomaBravo: {
    src: thomaBravoLogo,
    alt: "Thoma Bravo",
    mobileHeight: 40,
    desktopHeight: 78,
  },
  blackRock: {
    src: blackRockLogo,
    alt: "BlackRock",
    mobileHeight: 34,
    desktopHeight: 56,
  },
  nasa: {
    src: nasaLogo,
    alt: "NASA",
    mobileHeight: 42,
    desktopHeight: 64,
  },
  generalDynamics: {
    src: generalDynamicsLogo,
    alt: "General Dynamics",
    mobileHeight: 38,
    desktopHeight: 56,
  },
  dod: {
    src: dodLogo,
    alt: "DOD",
    mobileHeight: 54,
    desktopHeight: 96,
  },
  visa: {
    src: visaLogo,
    alt: "Visa",
    mobileHeight: 46,
    desktopHeight: 80,
  },
  paypal: {
    src: payPalLogo,
    alt: "PayPal",
    mobileHeight: 40,
    desktopHeight: 64,
  },
  ebay: {
    src: eBayLogo,
    alt: "eBay",
    mobileHeight: 40,
    desktopHeight: 64,
  },
};
